import * as utils from '../../../shared/utils';

export default function getDetailsPanelEditable() {
  try {
    return utils.LocalStorage.get('picsio.detailsPanelEditable') || {};
  } catch (err) {
    return {};
  }
};
